import { Provider } from 'react-redux';
import 'assets/scss/style.scss';
import { BrowserRouter } from 'react-router-dom';
import * as ReactDOM from 'react-dom/client';
import { Amplify } from 'aws-amplify';
import { AmplifyProvider } from 'aws-auth-lib';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RoleProvider } from './utils/RoleContext';
import { awsAuthConfig } from './configs/aws';
import { ClinicProvider } from './utils/ClinicContext';
import { AppProvider } from './utils/AppContext';
import { i18nReady } from './i18n';
import { reducer } from 'store';
import App from 'App';

// ==============================|| REACT DOM RENDER  ||============================== //

Amplify.configure(awsAuthConfig);

const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement);
const queryClient = new QueryClient();

const renderApp = () => {
    root.render(
        <AmplifyProvider config={awsAuthConfig}>
            <QueryClientProvider client={queryClient}>
                <Provider store={reducer}>
                    <AppProvider>
                        <RoleProvider>
                            <ClinicProvider>
                                <BrowserRouter>
                                    <App />
                                </BrowserRouter>
                            </ClinicProvider>
                        </RoleProvider>
                    </AppProvider>
                </Provider>
            </QueryClientProvider>
        </AmplifyProvider>
    );
};

i18nReady.then(renderApp, renderApp);
